interface IJsonLdProps {
  schema: string;
  testId?: string;
}
export const JsonLd = ({ schema, testId }: IJsonLdProps) => {
  // Escape </script> to prevent XSS while preserving valid JSON (no HTML entities)
  const safeSchema = schema.replace(/<\/script>/gi, '<\\/script>');

  return (
    <script
      type="application/ld+json"
      data-testid={testId}
      dangerouslySetInnerHTML={{ __html: safeSchema }}
    />
  );
};
